export const predicateBuscarValidaciones = (tipoPersona, producto, formulario) => (
  validacion,
) => {
  if (validacion?.validationCriteria !== 'onSubmit') {
    return false;
  }

  if (validacion.producto && validacion?.producto !== producto) {
    return false;
  }
  if (validacion.formulario && validacion?.formulario !== formulario) {
  }

  return validacion?.showOn?.includes?.(tipoPersona);
};
